import { Navigate, Outlet } from 'react-router-dom'

import useAuth from '../../lib/hooks/use-auth'
import { OLTypeEnum } from '../../lib/types/enums/ol/ol-type.enum'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { getUserDefaultRedirectionPath } from '../pages/login/utils'

/**
 * Mirrors the navbar condition of the One to One Individuel surface: an admin always reaches it,
 * and a prestataire only when it is flagged as One to One Individuel.
 * @see `getNavbarItems` (`ol-oto-individual-places`) and `SidebarManager`
 */
export default function OtoIndividualGuard() {
  const { user } = useAuth()

  const hasPermission =
    user.role === RoleEnum.ADMIN ||
    (user.ol?.type === OLTypeEnum.PARTNER && !!user.ol.isOtoIndividual)

  return hasPermission ? <Outlet /> : <Navigate replace to={getUserDefaultRedirectionPath(user)} />
}
